import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Tag } from "primereact/tag";
import { Button } from "primereact/button";
import { API } from "./App";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import FileUploadModal from "./FileUploadModal";
import { getAuthHeader } from "./AuthRoute";
import GenerateExcelButton from "./GenerateButtonExcel";

function ProjectSondages() {
  const navigate = useNavigate();
  const { projectName, pageNbr } = useParams();
  const { sondageId } = useParams(); // Get sondageId from the URL
  const { docNumber } = useParams(); // Get sondageId from the URL

  const [sondages, setSondages] = useState([]);
  const [page, setPage] = useState(pageNbr ? pageNbr - 1 : 0);
  const [pageSize, setPageSize] = useState(5);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);

  const [showUploadDialog, setShowUploadDialog] = useState(false);

  const [loadingGenerateExcel, setLoadingGenerateExcel] = useState(false);

  function isAllSondagesMode() {
    return projectName === undefined || projectName === "all-sondages";
  }

  function allSondagesOrProjectSondages(page, pageSize) {
    if (isAllSondagesMode()) {
      return API() + "/sondages?page_index=" + page + "&page_size=" + pageSize;
    } else {
      return (
        API() +
        "/projects/" +
        projectName +
        "/sondages?page_index=" +
        page +
        "&page_size=" +
        pageSize
      );
    }
  }

  function loadSondages() {
    setLoading(true);
    fetch(allSondagesOrProjectSondages(page, pageSize), {
      headers: { Authorization: getAuthHeader() },
    })
      .then((response) => {
        if (response.status === 200) {
          return response;
        } else {
          throw new Error("Failed to fetch project files");
        }
      })
      .then((response) => response.json())
      .then((data) => {
        setTotalRecords(data.total_records);
        data = data.page_sondages;
        for (let i = 0; i < data.length; i++) {
          data[i].doneTxt =
            "Done " +
            data[i].documents.filter(
              (doc) => doc.exomap_status.status === "done",
            ).length +
            "/" +
            data[i].documents.length;
          data[i].done =
            data[i].documents.filter(
              (doc) => doc.exomap_status.status === "done",
            ).length > 0;

          if (
            data[i].interpretation == null ||
            data[i].interpretation.status === null
          ) {
            data[i].interpretationStatus = "Not started";
          } else if (data[i].interpretation.status === "done") {
            data[i].interpretationStatus = "Done";
          } else {
            data[i].interpretationStatus = "Not done";
          }
        }
        setSondages(data);
        setLoading(false);
      })
      .catch((error) => {
        setSondages([]);
        setLoading(false);
        alert("Error: " + (error.message || "no message"));
      });
  }

  useEffect(() => {
    if (pageNbr === undefined) {
      setPage(0);
      navigate(`/${projectName}/project/1`);
    }
    if (
      projectName !== undefined &&
      sondageId !== undefined &&
      docNumber !== undefined
    ) {
      navigate(`/${projectName}/sondage/${sondageId}/docnbr/${docNumber}`);
    } else {
      loadSondages();
    }
  }, [projectName, page, pageSize]);

  const handleFileClick = (sondageId) => {
    navigate(`/${projectName}/sondage/${sondageId}/docnbr/0`);
  };

  const statusBodyTemplate = (rowData) => (
    // <Tag
    //   value={rowData.doneTxt}
    //   severity={rowData.done ? "success" : "danger"}
    // />
    <Tag
      value={rowData.interpretationStatus}
      severity={
        rowData.interpretationStatus === "Done"
          ? "success"
          : rowData.interpretationStatus === "Not started"
            ? "warning"
            : rowData.interpretationStatus === "Not done"
              ? "danger"
              : "info"
      }
    />
  );

  const commentsTemplate = (rowData) => (
    <div>
      {rowData.comments ? rowData.comments.length + " comments" : "No comments"}
    </div>
  );

  const modificationDateTemplate = (rowData) => {
    if (rowData.interpretation && rowData.interpretation.updated_at) {
      const date = new Date(rowData.interpretation.updated_at);
      return (
        <div>
          {date.toLocaleDateString() +
            " " +
            date.toLocaleTimeString() +
            " by " +
            rowData.interpretation.updated_by}
        </div>
      );
    } else {
      return <div>No modification date</div>;
    }
  };

  const actionBodyTemplate = (rowData) => (
    <React.Fragment>
      <div style={{ display: "inline-flex", gap: "0.5rem" }}>
        <Button
          label="Open"
          className="p-button-rounded p-button-info"
          onClick={() => handleFileClick(rowData._id)}
        />
        {/*<Button*/}
        {/*  label="Delete"*/}
        {/*  className="p-button-rounded p-button-danger"*/}
        {/*  onClick={() => {*/}
        {/*    const confirmed = window.confirm(*/}
        {/*      "Are you sure you want to delete this file? " +*/}
        {/*        rowData.sondage_name,*/}
        {/*    );*/}
        {/*    if (confirmed) {*/}
        {/*      fetch(API() + "/sondages/" + rowData._id, {*/}
        {/*        method: "DELETE",*/}
        {/*        headers: {*/}
        {/*          Authorization: getAuthHeader(),*/}
        {/*        },*/}
        {/*      })*/}
        {/*        .then((response) => {*/}
        {/*          if (response.status === 204) {*/}
        {/*            loadSondages();*/}
        {/*          } else {*/}
        {/*            response.text().then((errorMessage) => {*/}
        {/*              throw new Error(errorMessage);*/}
        {/*            });*/}
        {/*          }*/}
        {/*        })*/}
        {/*        .catch((error) => {*/}
        {/*          alert("Error: " + (error.message || "no message"));*/}
        {/*        });*/}
        {/*    }*/}
        {/*  }}*/}
        {/*/>*/}
      </div>
    </React.Fragment>
  );

  const handleOcrLaunch = (sondageId, docNumber) => {
    setTimeout(loadSondages, 100);
    setTimeout(loadSondages, 1000);

    fetch(API() + "/sondages/" + sondageId + "/" + docNumber + "/ocr", {
      headers: {
        Authorization: getAuthHeader(),
      },
    })
      .then((response) => {
        if (response.status === 200) {
          return response;
        } else {
          throw new Error("Failed to fetch OCR");
        }
      })
      .then((response) => response.json())
      .then((data) => {
        loadSondages();
      })
      .catch((error) => {
        alert("Error: " + (error.message || "no message"));
      });
  };

  function downloadSondage(sondageId, filename) {
    fetch(API() + "/sondages/" + sondageId + "/download", {
      headers: {
        Authorization: getAuthHeader(),
      },
    })
      .then((response) => {
        loadSondages();
      })
      .catch((error) => {
        alert("Error: " + (error.message || "no message"));
      });
  }

  const downloadBodyTemplate = (rowData) => (
    <React.Fragment>
      {rowData.documents.map((doc) => (
        <Tag
          key={rowData._id + doc.filename + doc.pdf_url}
          value={doc.filename}
          style={{
            backgroundColor:
              doc.pdf_status.status === "success"
                ? "green"
                : doc.pdf_status.status === "error"
                  ? "red"
                  : doc.pdf_status.status === "pending"
                    ? "orange"
                    : "gray",
            color: "white",
          }}
          title={doc.filename + " " + doc.pdf_status.text}
          onClick={() => {
            downloadSondage(rowData._id, doc.filename);
          }}
        />
      ))}
    </React.Fragment>
  );

  const ocrBodyTemplate = (rowData) => (
    <React.Fragment>
      {rowData.documents.map((doc) => (
        <Tag
          key={rowData._id + doc.pdf_url}
          value={doc.filename}
          style={{
            backgroundColor:
              doc.ocr_status.status === "success"
                ? "green"
                : doc.ocr_status.status === "error"
                  ? "red"
                  : doc.ocr_status.status === "pending"
                    ? "orange"
                    : "gray",
            color: "white",
          }}
          title={doc.filename + " " + doc.ocr_status.text}
          onClick={() => {
            handleOcrLaunch(rowData._id, 0);
          }}
        />
      ))}
    </React.Fragment>
  );

  function loadProject() {
    fetch(API() + "/projects/" + projectName + "/load", {
      method: "GET",
      headers: {
        Authorization: getAuthHeader(),
      },
    })
      .then((response) => {
        if (response.status === 202) {
          return response;
        } else {
          throw new Error(
            "Error loading project " + projectName + " " + response.status,
          );
        }
      })
      .then((response) => response.text())
      .then((data) => {
        alert(data);
        loadSondages();
      });
  }

  return (
    <div className="card">
      <h3 style={{ padding: "10px" }}>
        {sondages
          ? (projectName ? "Project : " + projectName : "All sondages") +
            " (" +
            totalRecords +
            " docs)"
          : "Loading..."}
      </h3>
      {/*/!* Button to open the upload dialog *!/*/}
      {/*<Button*/}
      {/*  label="Upload Files"*/}
      {/*  style={{ margin: "10px" }}*/}
      {/*  icon="pi pi-upload"*/}
      {/*  onClick={() => setShowUploadDialog(true)}*/}
      {/*/>*/}
      {/* File upload modal */}
      <FileUploadModal
        visible={showUploadDialog}
        onHide={() => {
          setShowUploadDialog(false);
          loadSondages();
        }}
        projectName={projectName}
      />
      {/*<Button*/}
      {/*  label={"Load PDFs and launch OCR"}*/}
      {/*  style={{ margin: "10px" }}*/}
      {/*  icon="fa fa-hard-drive"*/}
      {/*  onClick={() => {*/}
      {/*    loadProject();*/}
      {/*  }}*/}
      {/*/>*/}
      <Button
        label={"Upload Excel"}
        style={{ margin: "10px" }}
        icon="fa fa-map"
        onClick={() => {
          setShowUploadDialog(true);
        }}
        tooltip={
          "Lors de l'import d'un fichier Excel, l'outil va :\n" +
          "1. Scanner le fichier pour identifier toutes les entrées `sondage_url`.\n" +
          '2. Analyser la feuille "Annexe" afin de déterminer les options disponibles pour Texture, Squelette et Compacité.\n' +
          "Remarque : L'import d'un nouveau fichier Excel remplacera le précédent sans perdre les interprétations (sauf si vous\n faites overwrite avec un Excel pas remplis)."
        }
      />
      <Button
        label={"Get original Excel"}
        style={{ margin: "10px" }}
        icon="fa fa-file-download"
        tooltip={"Download the latest Excel imported for this project."}
        onClick={() => {
          fetch(API() + "/projects/" + projectName + "/original-excel", {
            headers: {
              Authorization: getAuthHeader(),
            },
          })
            .then((response) => {
              if (response.status === 200) {
                return response;
              } else {
                throw new Error(
                  "Failed to fetch" + projectName + " original Excel",
                );
              }
            })
            .then((response) => response.blob())
            .then((blob) => {
              const url = window.URL.createObjectURL(new Blob([blob]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", `${projectName}_original.xlsx`);
              document.body.appendChild(link);
              link.click();
              link.parentNode.removeChild(link);
            })
            .catch((error) => {
              alert("Error: " + (error.message || "no message"));
            });
        }}
      />
      <GenerateExcelButton projectName={projectName} />
      <DataTable
        value={sondages}
        responsiveLayout="scroll"
        paginator={true}
        rows={pageSize}
        first={page * pageSize}
        totalRecords={totalRecords}
        lazy={true}
        onPage={(e) => {
          setPage(e.page);
          setPageSize(e.rows);
          navigate(`/${projectName}/project/${e.page + 1}`);
        }}
        loading={loading}
        rowsPerPageOptions={[5, 10, 20, 50, 100]}
        showGridlines={true}
      >
        <Column field="sondage_name" header="Sondage Name" />
        <Column field="done" header="Status" body={statusBodyTemplate} />
        <Column body={actionBodyTemplate} header="Actions" />
        {/*<Column body={downloadBodyTemplate} header="Downloaded" />*/}
        {/*<Column body={ocrBodyTemplate} header="OCR" />*/}
        <Column body={commentsTemplate} header="Comments" />
        <Column body={modificationDateTemplate} header="Last Modified" />
        <Column field="_id" header={"Sondage ID"} />
      </DataTable>
    </div>
  );
}

export default ProjectSondages;
